{
    "steps": {
        "min": 2,
        "max": 7
    },
    "currentStep": {
        "min": 1
    },
    "comments": {
        "steps": "StatusBar supports between 2-7 steps for optimal UX. Minimum 2 steps: Single step doesn't require progress indication. Maximum 7 steps: Beyond 7 steps becomes cluttered and hard to follow",
        "currentStep": "Current step must start from 1 (first step)"
    }
}
